"use strict";

// initial cart blocker check
let blockCheckout = false;
cartItems.forEach((item) => {
  if(item.properties.hasOwnProperty("Exclusive") && customerTags.length == 0) {
    blockCheckout = true;
    window.MicroModal.show("exclusive-warning-modal");
  }
});

// cart sections id
const cartSections = ["cart", "header"];

// cart update function
function cartUIUpdate(parsedData) {
  const cartTemplateHTML = new DOMParser().parseFromString(
    parsedData.sections["cart"],
    "text/html"
  );
  const globalHeaderHTML = new DOMParser().parseFromString(
    parsedData.sections["header"],
    "text/html"
  );

  if (parsedData.items.length > 0) {
    // header cart counter update
    document.querySelector(".it-cart--bubble").innerHTML =
    globalHeaderHTML.querySelector(".it-cart--bubble").innerHTML;
  } else {
    document.querySelector(".it-cart--bubble").remove();
  }

  // cart html update
  document.querySelector(".it-cart--left").innerHTML =
  cartTemplateHTML.querySelector(".it-cart--left").innerHTML;
  document.querySelector(".it-cart--sidebar").innerHTML =
  cartTemplateHTML.querySelector(".it-cart--sidebar").innerHTML;
}

// cart add API Request
function cartAddRequest(variantID, quantity,properties, el) {
  const body = JSON.stringify({
    items: [
      {
        id: variantID,
        quantity: quantity,
        properties: properties
      },
    ],
    sections: cartSections,
    sections_url: window.location.pathname,
  });

  fetch("/cart/add", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    ...{ body },
  })
    .then(function (res) {
      return res.text();
    })
    .then(function (data) {
      const parsedData = JSON.parse(data);
      if( parsedData.errors ) {
        document.querySelector(".it-cart--item").insertAdjacentHTML("beforeend",`<div style='width: 100%;padding: 10px;background-color: #f8f8f8;border-radius: 5px;' class='error-message'>${ parsedData.errors }</div>`);
        el.querySelectorAll(".it-cart--item-addon-button").forEach((el) => el.classList.contains("loader") ?? el.classList.remove("loader"));
      } else {
        cartUIUpdate(parsedData);
      }
    })
    .catch(function (error) {
      console.log(error);
    });
}

// cart change API Request
function cartChangeRequest(variantID, quantity) {
  const body = JSON.stringify({
    id: variantID,
    quantity: quantity,
    sections: cartSections,
    sections_url: window.location.pathname,
  });

  fetch("/cart/change", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    ...{ body },
  })
    .then(function (res) {
      return res.text();
    })
    .then(function (data) {
      const parsedData = JSON.parse(data);
      cartUIUpdate(parsedData);
    })
    .catch(function (err) {
      console.log(err);
    })
    .finally(function () {
      document
        .querySelector(".it-cart")
        .classList.remove("loader");
    });
}

// Remove Both product and sub

function removeSubBundle(itemArray) {
  let updates = {};

  itemArray.forEach(function(item) {
    updates[item] = 0;
  });

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(
      { 
        updates,
        sections: cartSections,
        sections_url: window.location.pathname,
      }
    )
  })
  .then(res => {
    return res.text();
  })
  .then(function (data) {
    const parsedData = JSON.parse(data);
    cartUIUpdate(parsedData);
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(function () {
    document
      .querySelector(".it-cart")
      .classList.remove("loader");
  });
}

// Cart Remove

class CartRemove extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.cartRemove);
  }

  cartRemove(event) {
    event.preventDefault();
    event.stopPropagation();

    document
      .querySelector(".it-cart")
      .classList.add("loader");

    if ( this.hasAttribute("data-variant-ids") ) {
      const variantIds = JSON.parse(this.dataset.variantIds);
      removeSubBundle(variantIds);
    } else {
      const variantID = this.dataset.variantId;
      cartChangeRequest(variantID, 0);
    }
    
  }
}

class CartQuantity extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("change", this.cartUpdate);
  }

  cartUpdate(event) {
    event.preventDefault();
    event.stopPropagation();

    document
      .querySelector(".it-cart")
      .classList.add("loader");

    if( event.target.value > 10 ) {
      window.MicroModal.show("quantity-modal");
    }

    const quantity = event.target.value;
    const variantID = event.target.dataset.variantId;

    cartChangeRequest(variantID, quantity);
  }
}

// DNA Addon

class CartDNAAddon extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.cartDNAAdd);
  }

  cartDNAAdd(event) {
    event.preventDefault();
    event.target.disabled = true;
    this.classList.add("loader");

    const quantity = 1;
    const variantID = event.target.dataset.id;
    const properties = JSON.parse(event.target.dataset.itemProperties);
    const el = this;

    if(document.getElementsByClassName("error-message").length > 0) {
      document.querySelector(".error-message").remove();
    }

    if(Object.keys(properties).length > 0) {
      grecaptcha.ready(function() {
        grecaptcha.execute('6LdelIkUAAAAAPXZT6dWInI4WBLs80eojVQTKSqX', {action: 'shopifyTags'}).then(function(token) {
          fetch("https://qabackbone.segterra.com/api/public/v1/shopify-tags", {
            method: "POST",
            body: JSON.stringify({
              "email": `${properties["_givy_recipient_email"]}`,
             "recaptchaToken": `${token}`,
             "recaptchaAction": "shopifyTags"
            })
          }).then(function(res) {
            return res.json();
          }).then(function(data) {
            if(data.tags.length > 0 && data.tags.includes("hasDNAProduct")) {
              // show error message
              document.querySelector(".it-cart--items").insertAdjacentHTML("beforeend",`<div style='width: 100%;padding: 10px;background-color: #8f1616;border-radius: 5px; color: #fff;' class='error-message'>This Recipient already has DNA Product.</div>`);
              el.classList.remove("loader");
            } else {
              cartAddRequest(variantID, quantity,properties, el); 
            }
          });
        });
      });
    } else {
       cartAddRequest(variantID, quantity,properties, this); 
    }
  }
}
// InnerAge Addon

class CartInnerAgeAddon extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.cartInnerAgeAdd);
  }

  async removeCurrentProduct(currentProductInfo,quantity, newVariantId) {
    const body = JSON.stringify({
      id: currentProductInfo.currentVariantId,
      quantity: quantity,
    });
  
    fetch("/cart/change", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      ...{ body },
    })
      .then(function (res) {
        return res.json();
      })
      .then(function () {
        const body = JSON.stringify({
          items: [
            {
              id: newVariantId,
              quantity: currentProductInfo.quantity,
              properties: currentProductInfo.properties
            },
          ],
          sections: cartSections,
          sections_url: window.location.pathname,
        });
      
        fetch("/cart/add", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          ...{ body },
        })
          .then(function (res) {
            return res.text();
          })
          .then(function (data) {
            const parsedData = JSON.parse(data);
            cartUIUpdate(parsedData);
          })
          .catch(function (err) {
            console.log(err);
          });
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  async cartInnerAgeAdd(event) {
    event.preventDefault();
    event.target.disabled = true;
    this.classList.add("loader");

    const currentProductInfo = {
      handle: event.target.dataset.productHandle,
      properties: JSON.parse(event.target.dataset.itemProperties),
      quantity: parseInt(event.target.dataset.productQty),
      currentOption: event.target.dataset.productCurrentOption,
      currentVariantId: event.target.dataset.productCurrentVariantId
    };


    const getProductInfo = await fetch(`${window.location.origin}/products/${currentProductInfo.handle}.js`);
    const getProductInfoRes = await getProductInfo.json();
    const getNewVariant = await getProductInfoRes.variants.filter(function(variant) {
      if (currentProductInfo.currentOption !== "") {
        return variant.public_title === `${currentProductInfo.currentOption.replace("No InnerAge", "InnerAge")}`;
      }
      return variant.public_title === `InnerAge 2.0`;
    });
    await this.removeCurrentProduct(currentProductInfo, 0, getNewVariant[0].id);
    
  }
}

// Women Biomarker Addon
class CartWomenBiomarkerAddon extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.cartHormoneAdd);
  }

  async removeCurrentProduct(currentProductInfo,quantity, newVariantId) {
    const body = JSON.stringify({
      id: currentProductInfo.currentVariantId,
      quantity: quantity,
    });
  
    fetch("/cart/change", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      ...{ body },
    })
      .then(function (res) {
        return res.json();
      })
      .then(function () {
        const body = JSON.stringify({
          items: [
            {
              id: newVariantId,
              quantity: currentProductInfo.quantity,
              properties: currentProductInfo.properties
            },
          ],
          sections: cartSections,
          sections_url: window.location.pathname,
        });
      
        fetch("/cart/add", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          ...{ body },
        })
          .then(function (res) {
            return res.text();
          })
          .then(function (data) {
            const parsedData = JSON.parse(data);
            cartUIUpdate(parsedData);
          })
          .catch(function (err) {
            console.log(err);
          });
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  async cartHormoneAdd(event) {
    event.preventDefault();
    event.target.disabled = true;
    this.classList.add("loader");

    const currentProductInfo = {
      handle: event.target.dataset.productHandle,
      properties: JSON.parse(event.target.dataset.itemProperties),
      quantity: parseInt(event.target.dataset.productQty),
      currentOption: event.target.dataset.productCurrentOption,
      currentVariantId: event.target.dataset.productCurrentVariantId
    };

    const getProductInfo = await fetch(`${window.location.origin}/products/${currentProductInfo.handle}.js`);
    const getProductInfoRes = await getProductInfo.json();
    const getNewVariant = await getProductInfoRes.variants.filter(function(variant) {
      return variant.public_title === `${currentProductInfo.currentOption.replace("No Estradiol + Progesterone", "Estradiol + Progesterone")}`;
    });
    await this.removeCurrentProduct(currentProductInfo, 0, getNewVariant[0].id);
    
  }
}

// cart scroll element
class CartScrollToSection extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.scrollToSection);
  }

  scrollToSection(event) {
    event.preventDefault();

    const targetElem = document.querySelector(`.${event.target.dataset.target}`);

    targetElem.scrollIntoView({
      behavior: "smooth",
      inline: "nearest",
      block: "end"
    });
  }
}

customElements.define("cart-scroll-section", CartScrollToSection);
customElements.define("cart-quantity", CartQuantity);
customElements.define("cart-remove", CartRemove);
customElements.define("cart-dna-addon", CartDNAAddon);
customElements.define("cart-innerage-addon", CartInnerAgeAddon);
customElements.define("cart-women-health-biomarker", CartWomenBiomarkerAddon);


document.querySelector(".it-cart--form").addEventListener("submit", function(event) {
  event.preventDefault();
});

// checkout

class CheckoutButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if(blockCheckout) {
      this.setAttribute("disabled", "disabled");
    } else {
      this.removeAttribute("disabled");
    
      this.addEventListener("click", (event) => {
        event.target.classList.add("loader");
        window.location.href = "/checkout";
      });
    }
  }
}

customElements.define("checkout-button", CheckoutButton)